import { Injectable } from '@angular/core';
import {BaseReactiveStore} from "../../shared/base-reactive-store";
import {OidcSecurityService} from "angular-auth-oidc-client";

export class AuthServiceState {
  isAuthenticated: boolean = false
}

@Injectable({
  providedIn: 'root'
})
export class AuthService extends BaseReactiveStore<AuthServiceState>{

  userData$ = this.oidc.userData$;

  constructor(private oidc: OidcSecurityService)
  {
    super(new AuthServiceState())
    oidc.isAuthenticated$.subscribe(value => this.setState({ isAuthenticated: value.isAuthenticated }))

  }

  isAuthenticated() {
    return this.state.isAuthenticated;
  }

  public login() {
    this.oidc.authorize()
  }

  public logout() {
    this.oidc.logoff().subscribe(() => { });
  }
}
